import $ from "jquery";

class SendEmailInscription {
  constructor() {
    this.events();
  }

  events() {
    const emailForm = document.querySelector("#email-inscription");
    const newsletterForm = document.querySelector("#newsletter-inscription");

    if (emailForm) {
      emailForm.addEventListener("submit", (e) => {
        e.preventDefault();
        this.submitForm();
      });
    }

    if (newsletterForm) {
      newsletterForm.addEventListener("submit", (e) => {
        e.preventDefault();
        this.submitForm();
      });
    }
  }

  submitForm() {
    const email = $("#email").val();
    const newsletterEmail = $("#newsletter-email").val();
    const data = email || newsletterEmail; // Assigns email value if available, otherwise assigns newsletterEmail
    const languageElement = document.querySelector(".lang-attribute");

    // Check if required elements exist
    if (!data || !languageElement) return;

    const language = languageElement.innerHTML;

    $.ajax({
      type: "POST",
      url: jsforwp_globals.ajax_url,
      data: {
        action: "email_inscription",
        _ajax_nonce: jsforwp_globals.nonce,
        email: data,
        language: language,
      },
      dataType: "json",
      success: (response) => {
        console.log(response.message);

        const emailInput = document.querySelector("input[type=email]");
        const alertContainer = $(".alert");
        const successContainer = $(".success");

        if (
          response.message === "Email already exists." ||
          response.message === "Email déjà enregistrer."
        ) {
          if (emailInput) emailInput.classList.add("email-error");
          alertContainer.html(`<p>${response.message}</p>`);
          successContainer.html(``);
        } else if (
          response.message === "Email saved successfully." ||
          response.message === "E-mail enregistré avec succès."
        ) {
          if (emailInput) emailInput.classList.remove("email-error");
          alertContainer.html(``);
          successContainer.html(`<p>${response.message}</p>`);

          // Check form existence before adding the class
          const emailForm = document.querySelector("#email-inscription");
          const newsletterForm = document.querySelector(
            "#newsletter-inscription"
          );
          if (emailForm) emailForm.classList.add("transparent");
          if (newsletterForm) newsletterForm.classList.add("transparent");
        } else if (
          response.message === "E-mail manquant un @, un .fr ou un .com." ||
          response.message === "E-mail missing an @, a .fr or a .com."
        ) {
          if (emailInput) emailInput.classList.add("email-error");
          successContainer.html(``);
          alertContainer.html(`<p>${response.message}</p>`);
        }
      },
      error: (response) => {
        console.log("Something went wrong");
        console.log(response);
      },
    });
  }
}

export default SendEmailInscription;
